/** Same persisted on/off action in all owner Setup catalogs. */
export function CatalogStatusSwitch({enabled,busy=false,disabled=false,
  label,onToggle}:{enabled:boolean;busy?:boolean;disabled?:boolean;
  label:string;onToggle:()=>void;}){
  return <button type="button" role="switch" aria-label={label}
    aria-checked={enabled} disabled={disabled||busy}
    className={'ecfs-catalog-status-switch '+(enabled?'is-on':'is-off')}
    title={enabled?'Disable':'Enable'} onClick={event=>{
      event.stopPropagation();onToggle();
    }}>{busy?'…':enabled?'on':'off'}</button>;
}
